import styles from '@styles/scss/performer/_imageGallery.module.scss';
import { Performer } from 'lib/types/item/performer';
import Image from 'next/dist/client/image';
import React, { useEffect, useRef } from 'react';

export default function ImageLightBox({
    images,
    lightBox,
    sendLightBox,
    sendBlur,
    performer,
    currentIndex,
    isMobile = false
}: {
    images: any[];
    lightBox: boolean;
    sendLightBox: any;
    sendBlur: any;
    performer: Performer;
    currentIndex: number;
    isMobile?: boolean;
}): JSX.Element {
    const length = images.length;

    function outsideLightBox(ref: any, ref2: any, ref3: any) {
        // Handles clicking anywhere outside of the chevrons or the lightbox to close it, and remove the blur
        useEffect(() => {
            function handleClickOutside(event: any) {
                if (
                    length === 2 &&
                    ref.current &&
                    !ref.current.contains(event.target) &&
                    ref2.current &&
                    !ref2.current.contains(event.target) &&
                    ref3.current &&
                    !ref3.current.contains(event.target)
                ) {
                    sendLightBox(false);
                } else if (length === 1 && ref.current && !ref.current.contains(event.target)) {
                    sendLightBox(false);
                    sendBlur('');
                }
            }

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref]);
    }

    const blurRef = useRef(null);
    const rightRef = useRef(null);
    const leftRef = useRef(null);
    outsideLightBox(blurRef, rightRef, leftRef);

    const currentItem = images[currentIndex];

    return (
        <>
            {lightBox ? (
                <div className={styles.lightBox}>
                    {typeof currentItem === 'string' ? (
                      <Image
                        loader={() => currentItem}
                        src={currentItem}
                        alt={`${performer.username} Photo ${currentIndex + 1} cam`}
                        height={600}
                        width={900}
                      />
                    ) : (
                      React.isValidElement(currentItem)
                        ? React.cloneElement(
                            currentItem as React.ReactElement<any>,
                            {
                              height: '',
                              width: isMobile ? '' : 700,
                            }
                          )
                        : currentItem
                    )}
                </div>
            ) : null}
        </>
    );
}
